<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">隐私声明</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Privacy Policy</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="about_main" v-if="lang == 'chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
        <div class="Section0" style="layout-grid: 18pt">
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >以下个人数据隐私声明是根据香港的《个人数据（隐私）条例》（</font
              ><font
                >“条例”）为了您与水木资产管理有限公司及其子公司和分支机构（统称为“水木</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>”</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>）的交易，以及您在不同时期向水木提供个人数据或信息（</font
              ><font
                >“数据”）而提供给您的。水木非常重视保护那些向我们提供个人信息个体的隐私权益，并致力于遵守条例的规定。为此，水木指示其员工遵守严格的内部安全和保密标准。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                >A.
              </span></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><font>收集</font></span
              ></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>1.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >您在不同时期需要向水木提供数据，以处理各种事项，如开设或继续账户，向您提供服务，或符合监管或其他机构发出的任何法律或指引。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>2.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >可能收集的数据种类包括但不限于：姓名和地址、职业、联系方式、生日和出生地，国籍，身份证、社会安全或国家保险号码，税收居民国，税号或护照号码，以及财务状况的细节。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>3.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >如未能提供此类数据，可能导致水木无法开设账户或继续向您提供服务，或无法遵守任何法律，监管或其他机构的规定或指引和守则。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>4.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >在您与水木的关系持续过程中，也会从您那里收集数据，例如，当您开设账户，转账或收款。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>5.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木的网站上也可能会收集更多数据，包括但不限于访客个人计算机的</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">IP</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >地址、查询的国家、访问的页面、访问的时间和浏览器类型。在水木网站上收集的数据并未电子加密。我们可能会使用软件工具收集关于网站访问者的浏览活动信息。所收集的信息可能由我们、我们的代理人或为水木提供服务的第三方处理。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                >B.
              </span></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><font>目的和使用</font></span
              ></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>1.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >数据可能被用于的目的会根据您与水木的关系性质而变化。水木打算将您的数据（包括您提供的任何第三方数据）用于以下任何一項或所有目的：</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.1 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >处理在水木开设账户的申请，包括确认和验证您的身份；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.2 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>提供给您的服务；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.3 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>任何与管理水木提供的产品和服务相关的目的；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.4 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >为客户研究、设计和推出金融、投资服务或相关产品；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.5 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >满足在香港或其他地方适用于水木的任何法律、法规、守则、指引或水木内部合规政策下的披露、报告和合规要求（包括但不限于税务报告）；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.6 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >根据您反对此类使用的权利，推广和直接营销以下服务和产品：</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.6.1 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>投资及相关服务和产品；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.6.2 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>金融、投资和教育研讨会和论坛；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.6.3 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>水木提供的其他金融服务和产品；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.7 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>使水木的任何实际或拟议的受让人能够行使其权利；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">1.8 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>与以上任何目的直接相关的其他目的。</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>2.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>您有权反对将您的数据用于直接营销目的，如上文第</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">1.6</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >段所述。如果您这样要求，水木将不再收费使用您的数据进行直接营销。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                >C.
              </span></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><font>直接营销</font></span
              ></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>1.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木意图使用所收集的数据进行直接营销，但除非收到您的同意（包括对预期使用无异议的表明），否则不得使用数据。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>2.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >此外，水木打算将所收集的数据提供给水木实体的全部或任何实质部分的业务的受让者（</font
              ><font
                >“受让者”）、服务提供者和相关的第三方（包括顾问）（与受让者一起，称为“各方”）</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">,</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >以供他们在直接营销中使用。然而，除非收到您的同意（包括对预期提供无异议的表示），否则不得提供数据。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>3.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木希望通过各种通讯手段（如直邮、电子邮件、电话、短信和宣传册）使用所收集的数据（包括但不限于您的姓名和联系方式</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">&nbsp;[</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>如电话号码、电子邮件地址和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>或通信地址</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">]</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >），或将其提供给所有或任何一方，以供各方使用。以下是直接营销的目的：</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">3.1 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>水木和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >或受让者的投资及相关服务和产品，金融、投资和教育研讨会和论坛，以及水木和</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>或受让者提供的其他金融服务和产品；和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">3.2 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>水木和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>或受让者的新产品和服务发布以及其他促销优惠。</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                >D.
              </span></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><font>保留和访问</font></span
              ></b
            ><b
              ><span
                style="
                  color: rgb(52, 56, 60);
                  font-weight: bold;
                  font-size: 16px;
                "
                ><o:p></o:p></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>1.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >将根据适用法律要求及根据上述目的的需要来维护收集的数据。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              text-indent: -24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>2.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木持有的与您相关的数据将被保密，水木将采取一切合理措施确保数据免于未经授权的访问、丢失、披露和破坏。水木可能会将此类信息提供给下列各方，无论他们是在香港境内还是境外，以实现上文</font
              ><font>“目的和使用”及“直接营销”部分所述的目的：</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.1 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>水木的子公司，代表处，联营公司和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>或分支机构；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.2 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木的服务提供商，包括托管人，投资经理，注册人，转让代理人，保管人，行政服务代理人和水木提供的每一产品的审计师；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.3 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >任何为水木提供与其业务运营相关的行政、研究、设计、发布、数字或电信、清算和结算或其他服务的代理商、承包商、分包商、顾问、保险商或第三方服务提供商；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.4 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>水木的员工、高級職員及董事；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.5 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >任何一方（包括但不限于、任何本地或外国政府、税务或监管机构，或有管辖权的法院），按照法律或法规应由其享有的，或应对其回应监管请求；</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.6 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >归属或不归属于水木的提供外包或其他服务的提供商，以及水木聘请的其他外部服务提供商（包括但不限于印刷厂、邮寄公司、数字或通信公司、信息技术公司、数据存储和基础设施公司、云服务供应商、数据处理公司和存储公司）以实现</font
              ><font>“目的和用途”部分第</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">1.6</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>段中规定的目的；和</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">2.7 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >水木的政策是要限制访问个人的数据给那些需要使用该数据，并已被指示正确处理该信息并保证保密的人员。持有线上交易权限的客户所使用的安全密码是电子加密的。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 23.8pt;
              text-indent: -23.8pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>3.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >请注意，转移到香港以外的数据可能会受到较低的保护级别，和</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">/</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >或不再受到香港任何相关的银行保密、客户保密或数据保护法律的保护。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>4.</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"> </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>根据条例，您有权：</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">4.1 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>查询水木是否持有您的数据，并访问这些数据；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">4.2 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>要求水木纠正与您有关的任何不准确的数据；</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              text-indent: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">4.3 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>查明水木在数据方面的政策和实践，</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">&nbsp;</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>并了解水木所持有的数据种类；以及</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px">4.4 </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >反对将您的数据用于直接营销的目的，而水木在收到您的反对通知后，将不使用您的数据进行直接营销。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="
              margin-bottom: 0;
              margin-left: 24pt;
              vertical-align: baseline;
            "
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >根据条例的条款，水木有权对处理任何数据请求收取合理的费用。</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font
                >要访问水木持有的关于您的数据，纠正该数据，反对将您的数据用于直接营销的目的，或获取关于政策和实践以及所持有的数据种类的信息，请联系：</font
              ></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>水木资产管理有限公司</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>资料保障主任</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>香港湾仔港湾道</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              >26</span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>号华润大厦</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              >3406A</span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>室</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>电邮</font></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              >: </span
            ><span
              ><a href="mailto:privacy@waterwood.one"
                ><u
                  ><span
                    class="21"
                    style="
                      mso-bidi-font-family: PMingLiU;
                      color: rgb(70, 120, 134);
                      text-decoration: underline;
                      text-underline: single;
                      font-size: 16px;
                    "
                    >privacy@waterwood.one</span
                  ></u
                ></a
              ></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>电话：</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">(852) </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>3468 5404</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>传真：</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px">(852) </span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><font>3186 2882</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font
                >为处理任何有关要求，本公司可能会要求您证明本人为所提出要求的有关人士，或为根据《条例》获准代表该名人士提出要求的人士。</font
              ></span
            ><span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            style="margin-bottom: 0; vertical-align: baseline"
          >
            <span
              style="
                mso-bidi-font-family: PMingLiU;
                color: rgb(52, 56, 60);
                font-size: 16px;
              "
              ><font>本声明一概不会限制您在上述条例下所享有的权利。</font></span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;</span
            ><span style="color: rgb(52, 56, 60); font-size: 16px"
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size:16px;16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
          <p
            class="MsoNormal"
            align="center"
            style="margin-bottom: 0; text-align: center"
          >
            <i
              ><span
                style="
                font-style:italic;font-size:16px;16px"
                >-</span
              ></i
            ><i
              ><span
                style="
                  font-style:italic;font-size:16px;16px"
                ><font>完</font></span
              ></i
            ><i
              ><span
                style="
                font-style:italic;font-size:16px;16px"
                >-</span
              ></i
            ><i
              ><span
                style="
                font-style:italic;font-size:16px;16px"
                ><o:p></o:p></span
            ></i>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-family:'Times New Roman';mso-fareast-font-family:DengXian;
              font-size:16px;16px"
              ><o:p>&nbsp;</o:p></span
            >
          </p>
        </div>
        <a
          href="http://8.217.65.217:1234/私隐政策声明.pdf"
          target="downloadFile"
          download
        >
          <div class="icon_box">
            <svg-icon class="PDF icon" icon-class="format-pdf" />
            <div class="icon_text text_right">PDF</div>
          </div>
        </a>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
        <div class="Section0" style="layout-grid: 18pt">
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >The following Personal Data Privacy Statement is provided to you
              pursuant to the Personal Data (Privacy) Ordinance of Hong Kong
              (“Ordinance”) in connection with your dealings with, and provision
              of personal data or information (“Data”) to, Waterwood Asset
              Management Limited and its holding companies, subsidiaries and
              affiliates (collectively, “Waterwood”) from time to time.
              Waterwood is fully committed to protecting the privacy interests
              of individuals who provide us with information about themselves
              and to comply with the requirements of the Ordinance. In doing so,
              Waterwood instructs its staff to comply with the strict internal
              standards of security and confidentiality.</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                "
                >A.</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                "
              >
              </span></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                "
                >Collection:</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                "
                ></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >1.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
              "
              >From time to time, it is necessary for you to supply Waterwood
              with Data in connection with various matters such as account
              opening or continuations, provision of services to you or
              compliance with any laws or guidelines issued by regulatory or
              other authorities.</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >2.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
              "
              >The kinds of Data that may be collected includes, but is not
              limited to, name and address, occupation, contact details, date
              and country of birth, nationality, identity card, social security
              or national insurance numbers, country of tax residence, tax
              reference numbers or passport numbers, and details of financial
              status.</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >3.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
              "
              >Failure to supply such Data may result in Waterwood being unable
              to open an account or continue to provide services to you or
              unable to comply with any laws or regulations or guidelines and
              codes issued by regulatory or other authorities.</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >4.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
              "
              >It is also the case that Data is collected from you in the
              ordinary course of the continuation of your relationship with
              Waterwood, for example, when you open an account, transfer or
              receive funds.</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >5.</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >Additional Data may also be collected at Waterwood’s websites
              which include, but is not limited to the IP address of the
              visitor’s personal computer, the country from which the inquiry is
              made, the pages visited, the time at which a visit is made and the
              browser type. The Data collected at Waterwood website is not
              electronically encrypted. We may use software tools to gather
              information about site visitors' browsing activities. The
              information collected may be processed by us, our agents or any
              other third parties which provide services to Waterwood.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                >B.</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
              >
              </span></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                >Purpose and Use:</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                ></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >The purposes for which Data may be used will vary depending on
              the nature of your relationship with Waterwood. Waterwood intends
              to use your Data (including any third party Data provided by you)
              for any or all of the following purposes:</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.1</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >the processing of an application for an account with Waterwood
              including confirming and verifying your identity;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.2 the services to be provided to you; </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.3 any purpose related to the administration of the products and
              services offered by Waterwood;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.4 researching, designing and launching financial, investment
              services or related products for clients;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.5 meeting the disclosure, reporting and compliance requirements
              (including but not limited to tax reporting) under any laws or
              regulations, codes, guidelines or internal Waterwood compliance
              policies applicable to Waterwood in Hong Kong or elsewhere;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.6 promoting and direct marketing of the following services and
              products subject to your right to object to such use:</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 42.45pt;
              mso-char-indent-count: 3.54;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.6.1 investment and related services and products;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 42.45pt;
              mso-char-indent-count: 3.54;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.6.2 financial, investment and educational seminars and
              forums;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 42.45pt;
              mso-char-indent-count: 3.54;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.6.3 other financial services and products offered by
              Waterwood;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.7 enabling any actual or proposed assignee(s) of
              Waterwood;</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.8 any other purpose directly related to any of the above.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >2.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >You have the right to object to the use of your Data for direct
              marketing purposes as set out in paragraph 1.6 above. Waterwood
              will cease to use your Data for direct marketing purposes without
              charge if you so request.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                >C.</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
              >
              </span></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                >Direct Marketing:</span
              ></b
            ><b
              ><span
                style="
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                ></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >Waterwood intends to use the Data collected for direct marketing
              but may not so use the Data unless you consent (which includes an
              indication of no objection to the intended use) is received.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >2.</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >Furthermore, Waterwood intends to provide the Data collected to
              all or any of the transferees of a whole or any substantial part
              of business of any Waterwood entity (the “Transferees”), service
              providers and related third parties (including consultants)
              (together with the Transferees, the “Parties”) for use by them in
              direct marketing. However, the Data may not be so provided unless
              you consent (which includes an indication of no objection to the
              intended provision) is received.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                
                
                
                font-size: 16px;
                
              "
              >3.</span
            ><span
              style="
                
                
                
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                
                
                
                font-size: 16px;
                
              "
              >Waterwood would like to use the Data collected, including but not
              limited to your name and contact details (such as telephone
              number, email address and/or correspondence address), or provide
              the same to all or any of the Parties for the Parties’ use, for
              the following direct marketing purposes through various
              communication means such as direct-mail, email, telephone, SMS and
              brochures:</span
            ><span
              style="
                
                
                
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                
                
                
                font-size: 16px;
                
              "
              >3.1 Waterwood’s and/or the Transferees’ investment and related
              services and products, financial, investment and educational
              seminars and forums or other financial services and products
              offered by Waterwood and/or the Transferees; and</span
            ><span
              style="
                
                
                
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                
                
                
                font-size: 16px;
                
              "
              >3.2 Waterwood’s and/or the Transferees’ new product and service
              launch and other promotional offers.</span
            ><span
              style="
                
                
                
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                
                
                
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <b
              ><span
                style="
                  
                  
                  
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                >D. Retention and Access:</span
              ></b
            ><b
              ><span
                style="
                  
                  
                  
                  font-weight: bold;
                  font-size: 16px;
                  
                "
                ></span
            ></b>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >1.</span
            ><span
              style="
                font-size: 16px;
                
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >The Data collected may be maintained for such period of time
              required under applicable law and as otherwise needed to fulfil
              the purposes set out above.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >2.</span
            ><span
              style="
                font-size: 16px;
              "
            >
            </span
            ><span
              style="
                font-size: 16px;
                
              "
              >Data held by Waterwood relating to you will be kept confidential
              and Waterwood will take all reasonable measures to ensure that
              Data is kept secure against unauthorized access, loss, disclosure
              and destruction. Waterwood may provide such information to the
              following parties, whether inside or outside of Hong Kong, for the
              purposes set out in the “Purpose and Use” and “Direct Marketing”
              sections above:</span
            ><span
              style="
                font-size: 16px;
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >font-size: 16px;
                
              "
              >2.1 the ultimate holding company of Waterwood, its subsidiaries,
              representative offices, associated companies and/or
              affiliates;</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.2 the service providers of Waterwood including the trustee,
              investment manager, registrar, transfer agent, the custodian,
              administrative service agent, and the auditor of each product
              offered by Waterwood;</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.3 any agent, contractor, subcontractor, consultant, insurer, or
              third party service provider who provides administrative,
              research, design, launch, digital or telecommunication, clearing
              and settlement or other services to Waterwood in connection with
              the operation of its business;</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.4 the employees, officers, directors of Waterwood;</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.5 any party (including but not limited to, any local or foreign
              governmental, tax or regulatory Authority, or court of competent
              jurisdiction) entitled thereto by law or regulation, or in
              response to a regulatory request;</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.6 affiliated or unaffiliated providers of outsourced or other
              services, and other external service providers of Waterwood
              (including but not limited to printing houses, mailing houses,
              digital or telecommunication companies, information technology
              companies, data storage and infrastructure companies, cloud
              providers, data processing companies and storage companies) that
              Waterwood engages for the purposes set out in paragraph 1.6 in the
              “Purpose and Use” section above; and</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >2.7 Waterwood’s policy is to restrict access to Data concerning
              individuals to those persons who have a need to use that Data and
              who have been instructed to handle such information properly and
              observe confidentiality. Security passcodes used by clients with
              on-line dealing privileges are electronically encrypted.</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >3.</span
            ><span
              style="font-size: 16px;
                
              "
            >
            </span
            ><span
              style="font-size: 16px;
                
              "
              >Please note that the Data transferred outside of Hong Kong may be
              subject a lower level of protection and/or cease to be protected
              by any relevant banking secrecy, client confidentiality or data
              protection laws of Hong Kong.</span
            ><span
              style="font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="font-size: 16px;
                
              "
              >4.</span
            ><span
              style="font-size: 16px;
                
              "
            >
            </span
            ><span
              style="font-size: 16px;
                
              "
              >Under the Ordinance, you have the right to:</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >4.1 check whether Waterwood holds Data about you, and access to
              such Data; </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >4.2 require Waterwood to correct any Data relating to you which
              is inaccurate; </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >4.3 ascertain Waterwood’s policies and practices in relation to
              data and to be informed of the kinds of Data held by Waterwood;
              and </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;&nbsp;&nbsp;&nbsp;4.4 object to the use of your Data for
              direct marketing purposes and Waterwood shall not use your Data
              for direct marketing purposes after you communicate your objection
              to Waterwood. </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >In accordance with the terms of the Ordinance, Waterwood has the
              right to charge a reasonable fee for the process of any data
              request. </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >For access to your Data held by Waterwood, correction of such
              Data, objection to use of your Data for direct marketing purposes
              or for information regarding policies and practices and kinds of
              Data held, please contact:</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >The Data Protection Officer </span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >Waterwood Asset Management Limited</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >Suite 3406A, China Resources Building</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
              "
              >26 Harbour Road, Wanchai, Hong Kong</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >Email: </span
            ><span
              ><a href="mailto:privacy@waterwood.one"
                ><u
                  ><span
                    class="18"
                    style="
                      color: rgb(70, 120, 134);
                      text-decoration: underline;
                      text-underline: single;
                    "
                    >privacy@waterwood.one</span
                  ></u
                ></a
              ></span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >Telephone: (852) 34685404</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              margin-left: 21.25pt;
              mso-para-margin-left: 1.77gd;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >Fax: (852) 31862882</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >In order to deal with any such request, Waterwood may require
              evidence from you that you are the individual in respect of whom
              the request is made or a person permitted under the Ordinance to
              make the request on that individual's behalf.</span
            ><span
              style="
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              text-indent: 24pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                font-size: 16px;
                
              "
              >Nothing in this statement shall limit your rights under the
              Ordinance.</span
            ><span
              style="
                mso-fareast-font-family: 等线;
                font-size: 16px;
                
              "
              ><o:p></o:p
            ></span>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                mso-fareast-font-family: 等线;
                font-size: 16px;
                
              "
              >&nbsp;</span
            >
          </p>
          <p
            class="MsoNormal"
            align="center"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: center;
            "
          >
            <i
              ><span
                style="
                  mso-fareast-font-family: 等线;
                  font-style: italic;
                  font-size: 16px;
                  
                "
                >- End -</span
              ></i
            ><i
              ><span
                style="
                  
                  
                  mso-fareast-font-family: 等线;
                  font-style: italic;
                  font-size: 16px;
                  
                "
                ></span
            ></i>
          </p>
          <p
            class="MsoNormal"
            align="justify"
            style="
              margin-bottom: 0pt;
              mso-layout-grid-align: none;
              layout-grid-mode: char;
              text-align: justify;
              text-justify: inter-ideograph;
            "
          >
            <span
              style="
                mso-fareast-font-family: 等线;
                font-size: 16px;
              "
              >&nbsp;</span
            >
          </p>
        </div>

        <a
          href="http://8.217.65.217:1234/PrivacyStatement.pdf"
          target="downloadFile"
          download
        >
          <div class="icon_box">
            <svg-icon class="PDF icon" icon-class="format-pdf" />
            <div class="icon_text text_right">PDF</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      lang: "",
      mianText: {
        title: "私隐政策声明",
        titleE: "Privacy Statement",
      },
    };
  },
  methods: {},
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
@media print {
  .hidden {
    display: none;
  }
}
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 230px 90px;
  font-size: 18px;
}
.about_main_title {
  padding: 20px 0 30px;
}
.icon_box {
  float: right;
  width: 50px;
  height: 80px;
  font-size: 36px;
  color: #ccc;
  margin-bottom: 60px;
  cursor: pointer;
}
.icon_box:hover {
  color: #666;
}

.PDF {
  display: block;
  width: 36px;
  height: 36px;
}
.icon {
  margin: 0 5px;
}
.text_right {
  width: 46px;
  text-align: center;
}
.icon_text {
  font-size: 14px;
}
</style>